export default __webpack_public_path__ + "static/media/mist_grass_wick.25237bfc.png";